import { h, Component } from 'preact';

// Just an element that never updates
export default class GMapMap extends Component {

	constructor(props) {
		super(props);
	}

	shouldComponentUpdate() {
		return false;
	}

	render({ ...props }) {
		return (
			<div {...props} ref={props.domRef} />
		);
	}

}
